const getSiteContent2 = () => "wishlists - shared";

export default getSiteContent2;
